// Accepts two numbers and returns an array of two numbers that represent the percentages of each number in relation to the sum of the two numbers
function calculatePercentages(num1: number, num2: number, threshold = 100) {
  // Calculate the sum of the two numbers
  const sum = num1 + num2;

  // Calculate the percentage of each number
  let percentage1 = (num1 / sum) * 100;
  let percentage2 = (num2 / sum) * 100;

  // Check if any percentage exceeds the threshold
  if (percentage1 > threshold || percentage2 > threshold) {
    // Adjust the percentages to ensure they never exceed 100%
    const maxPercentage = Math.min(percentage1, percentage2, threshold);
    const remainingPercentage = 100 - maxPercentage;

    // Update the percentages
    percentage1 = (num1 / sum) * remainingPercentage;
    percentage2 = (num2 / sum) * remainingPercentage;
  }

  // Return the percentages as an array
  return [percentage1, percentage2];
}

export default calculatePercentages;
